import React from "react";

const TemarioDiplomaturaGinecologiaRegenerativaEsteticaFuncional = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Fundamentos y terapias bioregenerativas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Ginecología regenerativa, estética y funcional: conceptos y alcance"}</span></li>
                <li><span className="fw-light">{"Anatomía aplicada del tracto genital inferior"}</span></li>
                <li><span className="fw-light">{"Motivos de consulta frecuentes y examen físico"}</span></li>
                <li><span className="fw-light">{"PRP: fundamentos, obtención, preparación y almacenamiento"}</span></li>
                <li><span className="fw-light">{"Técnicas de aplicación en SGU, Liquen Escleroso y cicatrices"}</span></li>
                <li><span className="fw-light">{"G-Shot y O-Shot: indicaciones, técnica y resultados"}</span></li>
                <li><span className="fw-light">{"Plasma Gel y Exosomas: mecanismos de acción y evidencia"}</span></li>
            </ul>
            <br /><br />
            <b>{"Rellenos dérmicos y bioestimuladores inyectables"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Ácido Hialurónico: reologías y elección según indicación"}</span></li>
                <li><span className="fw-light">{"Aplicaciones: hidratación vaginal, voluminización y punto G"}</span></li>
                <li><span className="fw-light">{"Técnica de inyección, materiales y cuidados post-procedimiento"}</span></li>
                <li><span className="fw-light">{"Hidroxiapatita de Calcio: bioestimulación de colágeno e indicaciones"}</span></li>
                <li><span className="fw-light">{"Contraindicaciones y manejo de complicaciones"}</span></li>
            </ul>
            <br /><br />
            <b>{"Lipotransferencia y lipomodelación genital"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Fat Transfer: ventajas, desventajas e indicaciones"}</span></li>
                <li><span className="fw-light">{"Obtención, procesamiento y aplicación del tejido adiposo"}</span></li>
                <li><span className="fw-light">{"Aplicación en Liquen Escleroso y voluminización de labios mayores"}</span></li>
                <li><span className="fw-light">{"Lipomodelación del Monte de Venus: técnica y objetivos"}</span></li>
            </ul>
            <br /><br />
            <b>{"Estética vulvar y bioestimulación con hilos PDO"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Peeling y blanqueamiento genital: indicaciones y técnica"}</span></li>
                <li><span className="fw-light">{"Tipos de ácidos, aplicación y prevención de hiperpigmentación"}</span></li>
                <li><span className="fw-light">{"Hilos PDO: tipos, mecanismo de acción y técnica de aplicación"}</span></li>
                <li><span className="fw-light">{"Rejuvenecimiento vulvar y tensado con PDO"}</span></li>
            </ul>
            <br /><br />
            <b>{"Ginecología funcional avanzada: neuromodulación, toxina botulínica y suelo pélvico"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Toxina Botulínica: mecanismo de acción y tipos"}</span></li>
                <li><span className="fw-light">{"Indicaciones en vaginismo, vulvodinia e hiperhidrosis genital"}</span></li>
                <li><span className="fw-light">{"Diluciones, protocolos, contraindicaciones y efectos adversos"}</span></li>
                <li><span className="fw-light">{"Kinesiología de suelo pélvico e integración interdisciplinaria"}</span></li>
                <li><span className="fw-light">{"Biofeedback, electroestimulación y ejercicios hipopresivos"}</span></li>
                <li><span className="fw-light">{"Uso de dilatadores vaginales: indicaciones y asesoramiento"}</span></li>
            </ul>
            <br /><br />
            <b>{"Terapias energéticas: láser, HIFU y radiofrecuencia vaginal"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Tecnología láser: principios, tipos (CO2, Er:YAG) e indicaciones"}</span></li>
                <li><span className="fw-light">{"HIFU vaginal: mecanismo de acción y rejuvenecimiento"}</span></li>
                <li><span className="fw-light">{"Radiofrecuencia vaginal: calentamiento tisular y remodelación de colágeno"}</span></li>
                <li><span className="fw-light">{"Protocolos de tratamiento y consideraciones de seguridad"}</span></li>
            </ul>
            <br /><br />
            <b>{"Estrategias estético-funcionales en patologías genitales"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Liquen Escleroso y Liquen Plano: diagnóstico y terapias regenerativas"}</span></li>
                <li><span className="fw-light">{"Lesiones por HPV y láser: evidencia actual"}</span></li>
                <li><span className="fw-light">{"Síndrome Genitourinario e Incontinencia de Orina: tratamientos no quirúrgicos"}</span></li>
                <li><span className="fw-light">{"Hiperlaxitud vaginal e inesteticismos post-parto: abordaje integral"}</span></li>
            </ul>
            <br /><br />
            <b>{"Sexualidad y hormonas en el climaterio"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Cambios hormonales en la menopausia y su impacto sexual"}</span></li>
                <li><span className="fw-light">{"Alteraciones del deseo, excitación, lubricación y orgasmo"}</span></li>
                <li><span className="fw-light">{"Factores psicosociales, imagen corporal y vínculos en el climaterio"}</span></li>
                <li><span className="fw-light">{"Hormonas Bioidénticas: conceptos, evaluación y vías de administración"}</span></li>
                <li><span className="fw-light">{"Testosterona en la mujer: déficit, indicaciones y formas de administración"}</span></li>
            </ul>
            <br /><br />
            <b>{"Microbiota y ginecología funcional"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Microbiota vaginal y su relación con la salud íntima"}</span></li>
                <li><span className="fw-light">{"Prebióticos y probióticos: evidencia en ginecología"}</span></li>
                <li><span className="fw-light">{"Factores que alteran la microbiota y candidiasis recurrente"}</span></li>
            </ul>
            <br /><br />
            <b>{"Introducción a la cirugía cosmetoginecológica"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Anestesia local: solución de Klein y crema anestésica"}</span></li>
                <li><span className="fw-light">{"Labioplastia: técnicas trim y wedge, indicaciones pre y postoperatorias"}</span></li>
                <li><span className="fw-light">{"Aumento y lifting de labios mayores. Endolifting"}</span></li>
                <li><span className="fw-light">{"Vaginoplastia: corrección quirúrgica de la laxitud vaginal"}</span></li>
                <li><span className="fw-light">{"Manejo postoperatorio: dolor, higiene, seguimiento y complicaciones"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioDiplomaturaGinecologiaRegenerativaEsteticaFuncional;
